// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-modal .footer-content {
  --app-space-content-bottom: calc(var(--ion-safe-area-bottom, 0) + 20px);
}

ion-modal .footer-progress {
  padding-bottom: calc(var(--ion-safe-area-bottom, 0) + 20px);
}

.footer-progress {
  padding: 0 var(--space-content-right) 20px var(--space-content-left);
}

.footer-content {
  --flex-flow: row nowrap;
  --gap: 10px;
  --app-space-content-top: var(--space-md);
  --app-space-content-right: var(--space-content-right);
  --app-space-content-bottom: 20px;
  --app-space-content-left: var(--space-content-left);
  --background-content: var(--ion-color-background);
  display: flex;
  flex-flow: var(--flex-flow);
  justify-content: space-between;
  gap: var(--gap);
  padding: var(--app-space-content-top) var(--app-space-content-right) var(--app-space-content-bottom) var(--app-space-content-left);
  background-color: var(--background-content);
  border-top: 1.5px solid var(--color-grey-200);
}
.footer-content:empty {
  border-top: none;
  padding: 0;
}
.footer-content ion-button {
  flex-grow: 1;
  text-transform: none;
  font-weight: 700;
  font-size: var(--font-size-xl);
  line-height: var(--font-line-height-sm);
  height: 60px;
  margin: 0 0;
  white-space: normal;
  --box-shadow: none;
  --border-radius: var(--radius-md);
  --padding-start: 18px;
  --padding-end: 18px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/buttons-footer/buttons-footer.component.scss"],"names":[],"mappings":"AAAA;EACI,uEAAA;AACJ;;AAEA;EACI,2DAAA;AACJ;;AAEA;EACI,oEAAA;AACJ;;AAEA;EACI,uBAAA;EACA,WAAA;EACA,wCAAA;EACA,qDAAA;EACA,gCAAA;EACA,mDAAA;EACA,iDAAA;EAEA,aAAA;EACA,2BAAA;EACA,8BAAA;EACA,eAAA;EACA,kIAAA;EAEA,2CAAA;EACA,6CAAA;AADJ;AAGI;EACI,gBAAA;EACA,UAAA;AADR;AAII;EACI,YAAA;EACA,oBAAA;EACA,gBAAA;EACA,8BAAA;EACA,uCAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EAEA,kBAAA;EACA,iCAAA;EACA,qBAAA;EACA,mBAAA;AAHR","sourcesContent":["ion-modal .footer-content {\r\n    --app-space-content-bottom: calc(var(--ion-safe-area-bottom, 0) + 20px);\r\n}\r\n\r\nion-modal .footer-progress {\r\n    padding-bottom: calc(var(--ion-safe-area-bottom, 0) + 20px);\r\n}\r\n\r\n.footer-progress {\r\n    padding: 0 var(--space-content-right) 20px var(--space-content-left);\r\n}\r\n\r\n.footer-content {\r\n    --flex-flow: row nowrap;\r\n    --gap: 10px;\r\n    --app-space-content-top: var(--space-md);\r\n    --app-space-content-right: var(--space-content-right);\r\n    --app-space-content-bottom: 20px;\r\n    --app-space-content-left: var(--space-content-left);\r\n    --background-content: var(--ion-color-background);\r\n\r\n    display: flex;\r\n    flex-flow: var(--flex-flow);\r\n    justify-content: space-between;\r\n    gap: var(--gap);\r\n    padding: var(--app-space-content-top) var(--app-space-content-right)\r\n        var(--app-space-content-bottom) var(--app-space-content-left);\r\n    background-color: var(--background-content);\r\n    border-top: 1.5px solid var(--color-grey-200);\r\n\r\n    &:empty {\r\n        border-top: none;\r\n        padding: 0;\r\n    }\r\n\r\n    ion-button {\r\n        flex-grow: 1;\r\n        text-transform: none;\r\n        font-weight: 700;\r\n        font-size: var(--font-size-xl);\r\n        line-height: var(--font-line-height-sm);\r\n        height: 60px;\r\n        margin: 0 0;\r\n        white-space: normal;\r\n\r\n        --box-shadow: none;\r\n        --border-radius: var(--radius-md);\r\n        --padding-start: 18px;\r\n        --padding-end: 18px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
